const checkIsraelCardholderId = (id = '') => {
  if ((id === '') || (id === null) || (id.toString().length > 9)) {
    return false;
  }

  let idString = id.toString();

  while (idString.length < 9) {
    idString = `0${idString}`;
  }

  const parsedId = idString.split('');

  const sumValue = parsedId
    .map((item, idx) => {
      const multiplier = (idx % 2 === 0) ? 1 : 2;
      return item * multiplier;
    })
    .reduce((acc, value) => {
      acc += (value > 9) ? (value % 10) + 1 : value;
      return acc;
    }, 0);

  const result = sumValue % 10;

  return !(isNaN(result) || result > 0);
};

export default checkIsraelCardholderId;
